// client/src/routes/app/tenants/$tenantId/payments.tsx — SCR-TEN-002 tab „Plăți" · D-2863.

import { createFileRoute } from '@tanstack/react-router';

import { MoneyTab } from '@/features/tenants/MoneyTab';

export const Route = createFileRoute('/app/tenants/$tenantId/payments')({
  component: MoneyTabScreen,
});

function MoneyTabScreen() {
  const { tenantId } = Route.useParams();
  return <MoneyTab tenantId={tenantId} />;
}
